import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, Btn, Field, Select } from "@/components/erp/ui";
import { toast } from "sonner";

const PROVIDERS = { openai: "ChatGPT (OpenAI)", anthropic: "Claude (Anthropic)", gemini: "Gemini (Google)" };

// Owner memilih satu model AI untuk semua fitur AI ERP
export const AiModelSettings = ({ owner }) => {
  const [v, setV] = useState(null);
  useEffect(() => { api.get("/settings/ai-model").then(({ data }) => setV(data)).catch(() => {}); }, []);
  if (!v) return null;
  const setProvider = (p) => setV({ ...v, provider: p, model: v.options[p][0] });
  const save = async () => {
    try { const { data } = await api.put("/settings/ai-model", { provider: v.provider, model: v.model }); setV(data); toast.success("Model AI tersimpan"); }
    catch (e) { toast.error(e.response?.data?.detail || "Gagal"); }
  };
  return (
    <Card className="p-5 max-w-xl" data-testid="ai-model-settings">
      <div className="font-semibold mb-1">Model AI</div>
      <p className="text-xs text-slate-500 mb-4">Dipakai untuk: tulis pesan WA / email approval ke customer, estimasi design dari foto, dan baca foto NPWP.</p>
      <div className="grid sm:grid-cols-2 gap-3">
        <Field label="Penyedia"><Select data-testid="ai-provider-select" disabled={!owner} value={v.provider} onChange={(e) => setProvider(e.target.value)}>{Object.keys(v.options).map((p) => <option key={p} value={p}>{PROVIDERS[p] || p}</option>)}</Select></Field>
        <Field label="Model"><Select data-testid="ai-model-select" disabled={!owner} value={v.model} onChange={(e) => setV({ ...v, model: e.target.value })}>{v.options[v.provider].map((m) => <option key={m}>{m}</option>)}</Select></Field>
      </div>
      {owner ? <Btn className="mt-4" data-testid="ai-model-save" onClick={save}>Simpan</Btn> : <p className="text-xs text-slate-400 mt-3">Hanya owner yang bisa mengganti model.</p>}
    </Card>
  );
};
